import { SetStateAction } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    CadastrarVisitaVendasController,
    ListarPontosVendaController,
} from "../../../../Controllers/Vendas/Compromisso/CompromissoController";
import { ICompromissoRequest } from "../../../../Interfaces/Vendas/Compromisso/CompromissoInterface";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { IListarCasoResponse } from "../../../../Interfaces/Vendas/Caso/CasoInterface";

interface ICadastrarVisita {
    setShow: (value: SetStateAction<boolean>) => void;
    caso?: IListarCasoResponse;
    updateList?: (...args: any[]) => Promise<IListarCasoResponse[]>;
}

export default function CadastrarVisita(props: ICadastrarVisita) {
    const FormMethods = useForm();

    const { Atendimento, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { execute: CadastrarVisita, loading: CadastrarVisitaLoading } =
        useAsyncCallback(CadastrarVisitaVendasController);

    function handleCadastrarVisita(formData: ICompromissoRequest) {
        CadastrarVisita({
            ...formData,
            ID_CASO: Atendimento?.ID_CASO
                ? Atendimento?.ID_CASO
                : props.caso?.ID_CASO ?? 0,
            ID_USUARIO_RESPONSAVEL: Atendimento?.ID_USUARIO_RESPONSAVEL
                ? Atendimento?.ID_USUARIO_RESPONSAVEL
                : props.caso?.ID_CASO,
        }).then(() => {
            props.setShow(false);
            if (props.updateList) {
                props.updateList();
            }

            if (Atendimento?.ID_CASO) {
                ReloadHistorico();
                updateAtendimento();
            }
        });
    }

    return (
        <FormProvider {...FormMethods}>
            <UnForm handleSubmit={handleCadastrarVisita}>
                <div className="col-md-12">
                    <div className="form-group">
                        <UnForm.Input
                            label="Data"
                            name="DT_CASO_VISITA"
                            type="datetime-local"
                            registerOptions={{
                                required: "Selecione uma data e horário",
                            }}
                        />
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group">
                        <UnForm.Textarea
                            label="Comentário"
                            name="DS_DESCRICAO"
                            registerOptions={{
                                required: "Insira um comentário",
                            }}
                        />
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group">
                        <UnForm.LazySelect
                            controller={ListarPontosVendaController}
                            getDS={(ds) => ds.DS_PONTO_VENDA}
                            getKeyValue={(key) => key.ID_PONTO_VENDA}
                            label="Ponto de Venda"
                            name="ID_PONTO_VENDA"
                            registerOptions={{
                                required: "Selecione um ponto de venda",
                            }}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group">
                        <UnForm.Select
                            label="Tipo de visita"
                            name="ID_TIPO_VISITA"
                        >
                            <option></option>
                            <option value={1}>Agendada</option>
                            <option value={2}>Espontânea</option>
                            <option value={3}>Retorno</option>
                        </UnForm.Select>
                    </div>
                </div>

                {/* <div className="col-md-12">
                    <div className="form-group">
                    <UnForm.LazySelect
                      controller={ListarPontosVendaController}
                      getDS={(ds) => ds.DS_PONTO_VENDA}
                      getKeyValue={(key) => key.ID_PONTO_VENDA}
                            label="Tipo de visita"
                            name="ID_TIPO_VISITA"
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                </div> */}

                <UnForm.SubmitButton
                    icon={faPlus}
                    color="success"
                    loading={CadastrarVisitaLoading}
                    disabled={CadastrarVisitaLoading}
                    loadingSize="sm"
                    className="w-100"
                >
                    Cadastrar Visita
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
